import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { SectionHead } from "./SectionHead";

const COALITION = [
  ["Talent", "Global-calibre speakers secured early — before the programme is public."],
  ["Production", "A room and a broadcast experience worthy of the audience."],
  ["Audience", "700 carefully selected leaders, not anonymous footfall."],
  ["Distribution", "A story that starts months before 13 April and continues after it."],
  ["Partners", "A small coalition willing to build before the outcome is obvious."],
];

const EMPTY = { name: "", email: "", company: "", message: "", website: "" };

const PartnerForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [st, setSt] = useState({ busy: false, ok: "", err: "" });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setSt({ busy: true, ok: "", err: "" });
    try {
      const r = await api.post("/partner-inquiry", form);
      setSt({ busy: false, ok: r.data.message, err: "" });
    } catch (x) {
      setSt({ busy: false, ok: "", err: formatApiError(x.response?.data?.detail) });
    }
  };
  if (st.ok) return <p className="ns-lede mt" data-testid="ns-partner-ok">Thank you, {form.name.split(" ")[0] || "there"}. {st.ok}</p>;
  return (
    <form className="ns-form mt" onSubmit={submit} noValidate data-testid="ns-partner-form">
      <div className="ns-field"><label htmlFor="pn">Name</label><input id="pn" value={form.name} onChange={set("name")} required autoComplete="name" data-testid="ns-partner-name" /></div>
      <div className="ns-field"><label htmlFor="pe">Work email</label><input id="pe" type="email" value={form.email} onChange={set("email")} required autoComplete="email" data-testid="ns-partner-email" /></div>
      <div className="ns-field full"><label htmlFor="pc">Company</label><input id="pc" value={form.company} onChange={set("company")} required autoComplete="organization" data-testid="ns-partner-company" /></div>
      <div className="ns-field full"><label htmlFor="pm">What would you like to build with us?</label><textarea id="pm" rows={3} value={form.message} onChange={set("message")} required data-testid="ns-partner-message" /></div>
      <input className="ns-hp" tabIndex={-1} autoComplete="off" value={form.website} onChange={set("website")} aria-hidden />
      <div className="ns-form-foot">
        <button className="ns-btn" type="submit" disabled={st.busy} data-testid="ns-partner-submit">{st.busy ? "Sending …" : "Send"}<span className="ar">→</span></button>
        {st.err && <p className="ns-msg err" data-testid="ns-partner-err">{st.err}</p>}
      </div>
    </form>
  );
};

export const Partners = () => {
  const [open, setOpen] = useState(false);
  return (
    <section className="ns-sec pp" id="partners" data-testid="ns-partners">
      <div className="ns-wrap">
        <SectionHead nr="07" label="Partners" right="Partnerships in progress" />
        <div className="ns-grid">
          <div className="g-1-8">
            <h2 className="ns-h2" data-rv data-testid="ns-partners-h"><i>Built with partners.</i><i>Not sold to sponsors.</i></h2>
          </div>
          <div className="g-1-7">
            <p className="ns-lede" data-rv data-testid="ns-partners-lede">World-class events are built before they are sold out. Delivering at this level requires early commitment — from the organisers, the delivery team and a small group of partners who believe in the ambition before everyone else sees it.</p>
            <ul className="ns-ledger two mt-l" data-rv style={{ "--d": ".15s" }} data-testid="ns-coalition">
              {COALITION.map(([t, d]) => <li key={t}><span className="t">{t}</span><span className="d">{d}</span></li>)}
            </ul>
          </div>
          <div className="g-8-12">
            <div className="ns-status" data-rv style={{ "--d": ".2s" }} data-testid="ns-partner-status">
              <span className="ns-k">Where we are</span>
              <span className="st">Partnerships in progress</span>
              <p>The first partners are announced together with the programme. Positions are limited — one per category — and discussed directly. The first partners do not simply sponsor the event; they make the ambition possible.</p>
              {!open && <button className="ns-btn" type="button" onClick={() => setOpen(true)} data-testid="ns-partner-cta">Partner with us<span className="ar">→</span></button>}
            </div>
            {open && <PartnerForm />}
          </div>
        </div>
      </div>
    </section>
  );
};
